import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* emailSend(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_EMAIL_SEND_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_EMAIL_SEND_REQUEST
    });

    yield call(Http.post, `email`, {
      ...action.payload
    });

    yield put({
      type: Constants.GLOBAL_EMAIL_SEND_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-email-sent-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_EMAIL_SEND_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchEmailSend() {
  yield takeEvery(Constants.GLOBAL_EMAIL_SEND_START, emailSend);
}
